module.exports = __webpack_public_path__ + "media/images/badge-check-fed70eae9fb4c7d2a274b2989e7fb152.svg";